import { render, staticRenderFns } from "./ContentBody.vue?vue&type=template&id=94af6fa8"
import script from "./ContentBody.vue?vue&type=script&lang=js"
export * from "./ContentBody.vue?vue&type=script&lang=js"
import style0 from "./ContentBody.vue?vue&type=style&index=0&id=94af6fa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports